import TemplateView from '../../../TemplateView'
import TwoLevelSelection from '../../../controls/selectorControls/two_level_selection'
import Ext from 'Ext'
import UsersSelectorPanel from '../../../usersSelector/at_users_selector_panel'
import UserGroupNodeRenderer from './UserGroupNodeRenderer'
import {USERS_WITHOUT_GROUP_ID} from 'constants'


export default class UserSelectorPanel extends TemplateView {
    constructor({
        onChange = () => {},
    }) {
        super()

        this.callbacks = {
            onChange,
        }

        this.state = {
            assignedUserIds: [],
            assignedGroupIds: [],
            users: [],
            userGroups: [],
            isUGREnabled: false,
        }

        this.onAnyStatePropertyDeeplyChanged(['users', 'userGroups', 'isUGREnabled'], () => this._initPanel())
        this.onAnyStatePropertyChanged(['assignedUserIds', 'assignedGroupIds'], () => {
            this.panel.setSelection(new TwoLevelSelection(this.state.assignedGroupIds, this.state.assignedUserIds))
        })
    }

    templateHtml() {
        return '<div class="components_userSelectorPanel"/>'
    }

    afterRender() {
        this._initPanel()
    }

    update() {
        super.update()
        this.panel.update()
    }

    resetFilters() {
        this.panel.afterResetAction()
    }

    _initPanel() {
        this.getEl().empty()

        this.panel = new SelectorPanel({
            showShowInactiveCheckbox: true,
        })

        this.panel.initialize(
            this.state.isUGREnabled,
            false,
            this.state.users,
            this.state.userGroups,
        )

        this.panel.setSelectionChangedHandler(() => this._handleSelectionChanges())

        this.panel.init(this.getEl())

        this.panel.setSelection(new TwoLevelSelection(this.state.assignedGroupIds, this.state.assignedUserIds))
    }

    _handleSelectionChanges() {
        let changes = {
            assignedGroupIds: this.panel.getSelection().getFirstLevel(),
            assignedUserIds: this.panel.getSelection().getSecondLevel()
        }

        if (this.panel.getSelection().getFirstLevel().includes(USERS_WITHOUT_GROUP_ID)) {
            changes = {
                assignedGroupIds: changes.assignedGroupIds.filter(id => id !== USERS_WITHOUT_GROUP_ID),
                assignedUserIds: this.state.users.filter(user => user.userGroupId === USERS_WITHOUT_GROUP_ID).map(user => user.id)
            }
        }

        this.callbacks.onChange(changes)
    }
}

const SelectorPanel = Ext.extend(UsersSelectorPanel, {
    showPermissionIcons: false,
    title: "",
    selectionChangedOnShowInactive: false,

    init($el) {
        this.render($el[0])
        this.processFirstPanelOpen()
    },

    createGenericOptions() {
        this.genericOptions = []
    },

    createCustomOption() {
    },

    getFooterSection() {
        return []
    },

    getGenericOptionsSection() {
        return []
    },

    getCustomOptionSection() {
        const toolbox = new Ext.Container({
            cls: "userSelectorCustomControlsContainer",
            autoEl: "div",
            items: [
                this.viewByPanel,
                this.getCustomOptionButtonsSection()
            ]
        })
        return [toolbox]
    },

    getFilterWordsPopupCoordinates() {
        return this.userGroupsEnabled ? {x: -87, y: -3} : {x: 2, y: -3}
    },

    getDetailsSection() {
        return [this.selectorTree, this.showInactiveCheckboxContainer]
    },

    getUserGroupNodeRenderer: function() {
        return new UserGroupNodeRenderer(this.selectorTree, this.selectorFilter, this.getExpandCollapseCallback())
    },

    getCurrentOptionValue() {
        return this.customOptionValue
    },

    isCustomOptionSelected() {
        return true
    },

    setSelection(selection) {
        this.selectNodes(selection)
    },

    update() {
        this.selectorTree.refreshScroller()
    },
})


// WEBPACK FOOTER //
// ./web/js/panels/user/teamAssignmentsPanel/UserSelectorPanel.js